var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"overflow-scroller"},[_c('div',{ref:"container",staticClass:"scroll-container",class:{
      'scroll-x': _vm.direction === 'x',
      'scroll-y': _vm.direction === 'y'
    },on:{"scroll":_vm.onScroll}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78547cea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/overflow-scroller.vue
// module id = null
// module chunks = 